export default "__VITE_ASSET__DO4Jwq3m__"